// Import action creator
import { actionCreator } from '@ntersol/state-management';
import { Models } from '../models';

// Example of a standalone action creator with proper type
// Change search filters available to the map
export const filtersChanged = actionCreator<Models.QueryParamsSearchFilters | null>('FILTERS_CHANGED');
